<template>
  <div v-if="isMobile">
    <template v-if="isEmptySearchObject">
      <div v-if="searchObject.loading">
        <v-progress-linear :indeterminate="true" :color="$preloaderColor" />Loading Properties...
      </div>
      <title-with-message
        v-else
        title="No properties found"
        message="There are no properties for your selected inputs. Please try searching for another entry."
        :content-small="true"
        btn-option="Go To Search Home"
        @button-clicked="redirectToSearchHome()"
      />
    </template>
    <template v-else>
      <search-results-container
        :search-object="searchObject"
        :assign-to-client="assignToClient"
        @open-display-property="showPropertyDetails"
        @load-more-clicked="assignSearchElement"
      />
      <div v-if="searchObject.loading">
        <v-progress-circular id="lazyLoader" color="primary" indeterminate />
      </div>
    </template>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import SearchResultsContainer from '../../components/search/SearchResultsContainer.vue'
import TitleWithMessage from '../../components/uiUtils/TitleWithMessage.vue'
import searchContent from '../../components/mixins/searchContent'

export default {
  components: { SearchResultsContainer, TitleWithMessage },

  mixins: [searchContent],

  props: {
    assignToClient: {
      type: Object,
      default: () => {}
    }
  },

  mounted() {
    this.setShowingMobileBackButton(true)
  },

  destroyed() {
    this.setShowingMobileBackButton(false)
    this.setSearchResult(false)
  },

  methods: {
    ...mapMutations('common', {
      setSearchResult: 'SET_SEARCH_RESULT_PAGE',
      resetMultipleRequestedObject: 'RESET_MULTIPLE_REQUESTED_OBJECT',
      resetSearchTextParams: 'RESET_SEARCH_TEXT_PARAMS',
      clearLastNewQuery: 'CLEAR_LAST_NEW_QUERY'
    }),
    ...mapMutations('mobile', {
      setShowingMobileBackButton: 'SET_SHOWING_MOBILE_BACK_BUTTON'
    }),

    showPropertyDetails(selectedProperty) {
      this.$router.push({
        path: `search/${selectedProperty._id}`
      })
    },

    redirectToSearchHome() {
      this.resetMultipleRequestedObject()
      this.resetSearchTextParams()
      this.clearLastNewQuery()
      this.setAddressInputValue({ text: '', suggestion: false })
      this.$router.push({
        name: this.profileStatus === 'client' ? 'client-search' : 'agent-search'
      })
    }
  }
}
</script>

<style lang="sass">
#lazyLoader
  margin: 5rem 0 10rem
</style>
